/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  eqeqeq */
/** @jsx jsx */
import React, { useEffect } from "react";
import { css, jsx } from "@emotion/core";
import { useHistory } from 'react-router-dom';
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import CalendarForm from "components/molecules/CalendarForm";
import FormPadding from "components/atoms/Form/FormPadding";
import { Row, Col } from "react-grid-system";
import BodyText from "components/atoms/BodyText";
import RadioSelectForm from "components/molecules/RadioSelectForm";
import VerticalLabelSelectFormV2 from "components/molecules/VerticalLabelSelectFormV2";
import PrimaryButton, { SecondaryButton } from "components/atoms/Button";
import Icon from "components/atoms/Icon";
import IconLabelButton from 'components/molecules/IconLabelButton';
import ClickableIconButton from "components/atoms/ClickableIconButton";
import { useMonthlyShiftContext } from "./contextHook";
import moment from "moment";
import { fetchOrganizations, fetchShopPlan, fetchMonthlyShift, getShiftPatterns } from "../api";
import Checkbox from "components/molecules/Checkbox";
import { confirmMonthlyLockOutV1 } from "api/shift";
import SelectForm from "components/molecules/SelectForm";
import Calendar from "components/molecules/CalendarV1";

const Filters: React.FC = () => {
  const {
    setLoading,
    setOpenConfirmModal,
    loadEmploymentDone,
    filters: {
      orgs,
      setOrgs,
      dateFromStr,
      setDateFromStr,
      isAttendExists,
      setAttendExists,
      selectedOrg,
      setSelectedOrg,
      employmentOptions,
      setEmploymentOptions,
      viewPeriod,
      setViewPeriod,
      dateToStr,
      checkall,
      setCheckall,
      pageTotal,
      setPageTotal,
      setPageIndex
    },
    monthlyCalendar: { setMonthlyShifts, setStaffs, setShopPlan, setAchievementConfirm, shiftConfirm, setShiftConfirm, downloadPdf, achievementConfirm, downloadExcel },
  } = useMonthlyShiftContext();
  useEffect(() => {
    async function fetch() {
      setLoading(true);

      //check confirmed dates
      confirmMonthlyLockOutV1(selectedOrg, dateFromStr, dateToStr).then((response) => {
        setAchievementConfirm(response.achievementConfirm);
        setShiftConfirm(response.shiftConfirm);
      });

      //fetch Org tree
      fetchOrganizations().then((response) => {
        let formattedOrgs = response.map((item) => ({
          value: String(item.orgCode),
          label: `${item.orgCode} ${item.orgName}`,
        }));
        setOrgs(formattedOrgs);
      });

      //fetch Shopplan
      fetchShopPlan(dateFromStr, dateToStr, selectedOrg).then((response) => {
        setShopPlan(response);
      });

      //fetch Monthly shift
      let employmentIds = employmentOptions.reduce((prev, current) => (current.checked ? `${current.id},${prev}` : prev), "1");
      let monthlyData = await fetchMonthlyShift(dateFromStr, dateToStr, selectedOrg, isAttendExists, employmentIds);
      setStaffs(monthlyData.staffInfo);
      setMonthlyShifts(monthlyData);
      setPageTotal(monthlyData.page.totalPages);
      setLoading(false);
    }

    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateToStr, selectedOrg, isAttendExists, employmentOptions]);

  const history = useHistory();

  useEffect(() => {
    if (employmentOptions !== null && employmentOptions !== [] && loadEmploymentDone) {
      let sessionData = '';
      let list = employmentOptions.reduce((x: any, y: any) => {
        return y.checked === true ? [...x, y.value] : x;
      }, []);
      if (list.length === employmentOptions.length) {
        sessionData = 'all';
        setCheckall(true);
      } else {
        sessionData = list.join();
        setCheckall(false);
      }
      sessionStorage.setItem(`0/sessionData${window.location.pathname}.employmentOptions`, sessionData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employmentOptions, loadEmploymentDone])
  return (
    <FormPadding isSubForm={window.screen.width < 800} customStyle={css({paddingLeft: '0px', marginLeft: '0px'})}>
    <FormPadding customStyle={css({paddingLeft: '0px'})}>
      <Row css={css({ alignItems: 'baseline !important' })}>
        <Col md={2} lg={1}>
          <div css={css({ marginTop: "18px" })}>
            <BodyText>期間</BodyText>
          </div>
        </Col>
        <Col md={10} lg={11}>
          <FlexBox customStyle={
            css`
              @media only screen and (max-width : 768px) {
                flex-flow: wrap;
              }
            `
            }>
            <Col md={5} lg={3}>
              <FlexBox>
                <FlexBoxItem>
                  <Calendar 
                  openActionChevron={true}
                  modeAction={viewPeriod === 'monthly' ? 'month' : 'week'}
                   date={moment(dateFromStr).toDate()}
                   setDate={(date) => {
                      if(date){
                        let newdate = date ? moment(date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
                        setDateFromStr(newdate);
                        setPageIndex(1);
                        sessionStorage.setItem("attendStampList.monthlyShift.targetDateFrom", newdate);
                      }
                   }}
                  />
                </FlexBoxItem>
                {/* <FlexBoxItem customStyle={css({ marginLeft: '-35px' })}>
                  <ClickableIconButton onClick={() => {
                    const nextMonth = moment(dateFromStr).subtract(1, viewPeriod === 'monthly' ? 'month' : 'week').format('YYYY-MM-DD');
                    setDateFromStr(nextMonth);
                    setPageIndex(1);
                    sessionStorage.setItem('attendStampList.monthlyShift.targetDateFrom', nextMonth);
                  }}>
                    <Icon type="chevronLeft" color="" size="24px" />
                  </ClickableIconButton>
                </FlexBoxItem>
                {dateFromStr && (
                  <FlexBoxItem>
                    <ClickableIconButton onClick={() => {
                      const nextMonth = moment(dateFromStr).add(1, viewPeriod === 'monthly' ? 'month' : 'week').format('YYYY-MM-DD');
                      setDateFromStr(nextMonth);
                      setPageIndex(1);
                      sessionStorage.setItem('attendStampList.monthlyShift.targetDateFrom', nextMonth);
                    }}>
                      <Icon type="chevronRight" color="" size="24px" />
                    </ClickableIconButton>
                  </FlexBoxItem>
                )}
                <FlexBoxItem>
                  <ClickableIconButton onClick={() => {
                    const nextMonth = moment(dateFromStr).add(1, viewPeriod === 'monthly' ? 'month' : 'week').format('YYYY-MM-DD');
                    setDateFromStr(nextMonth);
                    setPageIndex(1);
                    sessionStorage.setItem('attendStampList.monthlyShift.targetDateFrom', nextMonth);
                  }}>
                    <Icon type="chevronRight" color="" size="24px" />
                  </ClickableIconButton>
                </FlexBoxItem> */}
              </FlexBox>
            </Col>
            <Col md={9} lg={9}>
              <div css={css({ display: "flex", alignItems: "baseline", marginLeft: "20px", marginTop: "-8px" },
              css`
                @media only screen and (max-width : 768px) {
                  margin: 0;
                  margin-top: 10px;
                  flex-flow: wrap;
                }
              `
              )}>
                <RadioSelectForm
                  label=""
                  name="haveShiftRecord"
                  items={[
                    {
                      label: "1週間表示",
                      value: "weekly",
                    },
                    {
                      label: "1ヶ月表示",
                      value: "monthly",
                    },
                  ]}
                  value={viewPeriod}
                  setValue={(e) => {
                    setViewPeriod(e.target.value);
                    setPageIndex(1);
                    sessionStorage.setItem(`0/sessionData${window.location.pathname}.viewPeriod`, e.target.value);
                  }}
                />
                <div css={css({ marginTop: '10px'})}>
                  <Checkbox
                    id="1"
                    name="isAttendExists"
                    label="シフト・実績有る人のみ表示"
                    value={"1"}
                    checked={isAttendExists === "1" ? true : false}
                    onChange={() => {
                      sessionStorage.setItem("attendStampList.attendFlag", isAttendExists === "1" ? "0" : "1");
                      setPageIndex(1);
                      setAttendExists(isAttendExists === "1" ? "0" : "1");
                    }}
                  />
                </div>
              </div>
            </Col>
          </FlexBox>
        </Col>
      </Row>  
    </FormPadding>
      <FormPadding customStyle={css({paddingLeft: '0px'})}>
        <Row>
          <Col lg={1} md={2} css={css({ display: 'flex', alignItems: 'center'})}>
            <div>
              <BodyText>組織</BodyText>
            </div>
          </Col>
          <Col lg={3} md={3}>
            <div css={css({ width: '480px'},
              css`
                @media only screen and (max-width : 768px) {
                  width: calc(100% + 265px);
                }
              `
            )}>
              <SelectForm
                label=""
                name="attendEmployment"
                value={selectedOrg}
                setValue={(orgCode) => {
                  setSelectedOrg(orgCode);
                  setPageIndex(1);
                  sessionStorage.setItem("attendStampList.monthlyShift.orgCode", orgCode);
                }}
                options={orgs}
                ghost={(['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") === -1 && orgs.length === 1)}
              />
            </div>
          </Col>
        </Row>
      </FormPadding>
      
      <FormPadding customStyle={css({paddingLeft: '0px'})}>
        <Row>
          <Col lg={1} md={2}>
            <div css={css({ marginTop: "8px" })}>
              <BodyText>雇用形態</BodyText>
            </div>
          </Col>
          <Col lg={11} md={10} css={css({ display: "flex", flexWrap: "wrap" })}>
            <div css={
              css`
                @media only screen and (max-width : 768px) {
                  margin-top: 10px;
                }
              `
            }>
              <Checkbox
                id={"all"}
                name={"checkall"}
                label="すべて"
                value={"1"}
                checked={checkall}
                onChange={(event) => {
                  let newEmploymentOptions = employmentOptions.map((option) => {
                    option.checked = !checkall;
                    return option;
                  });
                  setEmploymentOptions(newEmploymentOptions);
                  setPageIndex(1);
                  setCheckall(!checkall);
                }}
              />
            </div>
            {employmentOptions.map((option, key) => {
              return (
                <div key={key} css={css({ padding: "8px 10px 5px 0" })}>
                  <Checkbox
                    customStyleLabel={css({ 
                      maxWidth: '250px',
                      overflow: 'hidden',
                      display: 'block',
                      textOverflow: 'ellipsis'
                    })}
                    id={option.id}
                    name={option.label}
                    label={option.label}
                    value={option.value}
                    checked={option.checked}
                    onChange={(event) => {
                      let newEmploymentOptions = [...employmentOptions];
                      newEmploymentOptions[key].checked = event.target.checked;
                      setPageIndex(1);
                      setEmploymentOptions(newEmploymentOptions);
                    }}
                  />
                </div>
              );
            })}
          </Col>
        </Row>
      </FormPadding>
      <Row css={
        css`
          @media only screen and (max-width : 768px) {
            width: 106%;
          }
        `
      }>
        <FlexBox customStyle={css({ margin: "1rem 0", width: "100%", justifyContent: "flex-end" })}>
          {shiftConfirm?.isConfirmedAllDays ? (
            <SecondaryButton
              text="シフト確定解除"
              onClick={() => {
                setOpenConfirmModal(true);
              }}
            />
          ) : (
            <PrimaryButton
              text="シフト確定"
              disabled={achievementConfirm['isConfirmedAllDays'] || shiftConfirm['isConfirmedAllDays']}
              onClick={() => {
                setOpenConfirmModal(true);
              }}
            />
          )}
          <ClickableIconButton onClick={downloadPdf} additionalCss={css({ margin: "0 0 0 10px", cursor: "pointer" })}>
            <span className="print">
              <Icon type="printer" color="" size="24px" />
            </span>
          </ClickableIconButton>
          <FlexBoxItem>
            <IconLabelButton onClick={() => history.push("/monthlyShift/import")} iconType="addCircle" text="インポート" />
          </FlexBoxItem>
          <FlexBoxItem>
            <IconLabelButton
              onClick={downloadExcel}
              iconType="download"
              text="Excelダウンロード"
            />
          </FlexBoxItem>
        </FlexBox>
      </Row>
    </FormPadding>
  );
};

export default Filters;
